import React from 'react';
import {View} from 'react-native';
import {isNil} from 'lodash/fp';

import LoadingIndicator from '/component/base/LoadingIndicator';
import {ALL_CONTENT as ALL_CLIENT_CONTENT} from '/component/partial/reportCard/ClientReportPopover/ClientReportPopover.constant';
import {Loading as ClientReportLoading} from '/component/partial/reportCard/ClientReportPopover/Loading';
import {ALL_CONTENT as ALL_COACH_CONTENT} from '/component/partial/reportCard/CoachReportPopover/CoachReportPopover.constant';
import {Loading as CoachReportLoading} from '/component/partial/reportCard/CoachReportPopover/Loading';

import {styles} from './ReportRecordDefaultLoading.style';

interface ReportRecordDefaultLoadingProps {
  contentName: string;
}

const ReportRecordDefaultLoading: React.FC<ReportRecordDefaultLoadingProps> = ({
  contentName = '',
}: ReportRecordDefaultLoadingProps) => {
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  if (!isNil(ALL_COACH_CONTENT[contentName])) {
    return (
      <View style={styles.base}>
        <CoachReportLoading {...{contentName}} />
      </View>
    );
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  } else if (!isNil(ALL_CLIENT_CONTENT[contentName])) {
    return (
      <View style={styles.base}>
        <ClientReportLoading {...{contentName}} />
      </View>
    );
  }

  return (
    <View style={styles.base}>
      <View style={styles.loading}>
        <LoadingIndicator size="large" />
      </View>
    </View>
  );
};

export default ReportRecordDefaultLoading;
